module.exports = __webpack_public_path__ + "img/logo.d58e9c3c.svg";